<template>
	<div class="agency-application-english-name">

		<v-form ref="form">
			<egranty-text-input-field
				:disabled="readonly"
				v-model="valueInternal"
				label="Angielski tytuł wniosku"
				for="agency-application-english-name"
				id="agency-application-english-name"
				@change="(val) => $emit('input', val)"
			></egranty-text-input-field>
		</v-form>
	</div>
</template>

<script>
	import EgrantyTextInputField from "../../../../genericComponents/EgrantyTextInputField";

	export default {
		name: "AgencyApplicationEnglishName",
		components: {EgrantyTextInputField},
		methods: {
			validate() {
				return this.$refs['form'].validate();
			}
		},

		data() {
			return {
				valueInternal: ""
			};
		},

		watch: {
			value: {
				immediate: true,
				handler(val) {
					this.valueInternal = val;
				}
			}
		},

		props: {
			value: String,
			readonly: {
				default: false
			}
		},
	};
</script>

<style scoped>
	.agency-application-english-name {
		padding-left: 20px;
		padding-right: 20px;
		margin-bottom: 20px;
	}

</style>
